import { ref } from 'vue'

export interface ModalOptions {
  type?: 'alert' | 'confirm' | 'info' | 'success' | 'error'
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  showCloseButton?: boolean
  closeOnBackdrop?: boolean
}

export function useModal() {
  const isOpen = ref(false)
  const modalOptions = ref<ModalOptions>({
    type: 'info',
    message: '',
    confirmText: 'OK',
    cancelText: 'Abbrechen',
    showCloseButton: true,
    closeOnBackdrop: true
  })

  const resolveRef = ref<((value: boolean) => void) | null>(null)

  const show = (options: ModalOptions): Promise<boolean> => {
    modalOptions.value = {
      type: 'info',
      confirmText: 'OK',
      cancelText: 'Abbrechen',
      showCloseButton: true,
      closeOnBackdrop: true,
      ...options
    }
    isOpen.value = true

    return new Promise<boolean>((resolve) => {
      resolveRef.value = resolve
    })
  }

  const handleConfirm = () => {
    if (resolveRef.value) {
      resolveRef.value(true)
      resolveRef.value = null
    }
    isOpen.value = false
  }

  const handleCancel = () => {
    if (resolveRef.value) {
      resolveRef.value(false)
      resolveRef.value = null
    }
    isOpen.value = false
  }

  const handleClose = () => {
    if (resolveRef.value) {
      // Bei Alert/Info/Success/Error wird true zurückgegeben
      if (modalOptions.value.type === 'alert' || 
          modalOptions.value.type === 'info' || 
          modalOptions.value.type === 'success' || 
          modalOptions.value.type === 'error') {
        resolveRef.value(true)
      } else {
        resolveRef.value(false)
      }
      resolveRef.value = null
    }
    isOpen.value = false
  }

  // Convenience-Methoden
  const alert = (message: string, title?: string): Promise<boolean> => {
    return show({ type: 'alert', message, title })
  }

  const confirm = (message: string, title?: string): Promise<boolean> => {
    return show({ type: 'confirm', message, title })
  }

  const info = (message: string, title?: string): Promise<boolean> => {
    return show({ type: 'info', message, title })
  }

  const success = (message: string, title?: string): Promise<boolean> => {
    return show({ type: 'success', message, title })
  }

  const error = (message: string, title?: string): Promise<boolean> => {
    return show({ type: 'error', message, title })
  }

  return {
    isOpen,
    modalOptions,
    show,
    alert,
    confirm,
    info,
    success,
    error,
    handleConfirm,
    handleCancel,
    handleClose
  }
}















